// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1Bxie","cell":"ColumnAccessor_cell__rGFv5","firstCellAccent":"ColumnAccessor_firstCellAccent__11DkX"};